import { useEffect, useRef, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const useCuriosityDisclaimer = (allowedRoutes: string[] = []) => {
	const initialPathname = useLocation().pathname;
	const isInitiallyAllowed =
		allowedRoutes.length === 0 ||
		allowedRoutes.some((route) => !!matchPath(route, initialPathname));
	const [isOpen, setIsOpen] = useState(isInitiallyAllowed);

	const pathname = useLocation().pathname;
	const previousPathnameRef = useRef(pathname);

	useEffect(() => {
		if (pathname !== previousPathnameRef.current) {
			const showOnAll = allowedRoutes.length === 0;
			const isNowAllowed =
				showOnAll ||
				allowedRoutes.some((route) => !!matchPath(route, pathname));

			setIsOpen(isNowAllowed);
			previousPathnameRef.current = pathname;
		}
	}, [pathname, allowedRoutes]);

	return { isOpen, setIsOpen };
};
